import RowFilledIcon from './RowFilledIcon';

export default RowFilledIcon;
